import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';

import { useLocale } from 'lib/i18n/client';
import { withLocale } from 'lib/i18n/path';

import { useGalleryText } from './gallery-ui';

// The "Pro" badge of a locked paid gallery setting (spec decision 10): the control beside it is
// disabled, the tooltip says Pro is bought in the Matcha app, and a click opens the Subscription
// page. Shared by every locked setting.
export function PlanLockBadge({ testId }: { testId?: string }) {
  const { t } = useGalleryText();
  const navigate = useNavigate();
  const locale = useLocale();

  return (
    <Tooltip title={t.plan.lockedHint}>
      <Chip
        size="small"
        icon={<LockIcon fontSize="small" />}
        label={t.plan.badge}
        aria-label={`${t.plan.badge}. ${t.plan.lockedHint}`}
        data-testid={testId}
        onClick={() => navigate(withLocale('/subscription', locale))}
        sx={{ fontWeight: 600, cursor: 'pointer' }}
      />
    </Tooltip>
  );
}
